import React from 'react';

import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

import promoColors from '../../../../theme/promoColors';
import promoMedia from '../../../../theme/promoMedia';
import { PromoDangerouslyHtml } from '../PromoDangerouslyHtml/PromoDangerouslyHtml';
import IconSvg from '../widgets/Illustration/IconSvg';

const getBoxShadow = (props) => {
    if (props.variant === 'contentRow' || props.variant === 'iconTile') {
        return null;
    } else {
        return promoColors.shadowLoose;
    }
};

const commonCss = css`
    min-height: ${(props) => (props.variant === 'halfWidth' ? '240px' : props.variant === 'plain' ? '335px' : null)};
    border-radius: ${(props) => (props.variant === 'halfWidth' ? '20px' : props.variant === 'plain' ? '24px' : null)};

    ${promoMedia.tablet744} {
        min-height: ${(props) => (props.variant === 'plain' ? '328px' : null)};
        border-radius: ${(props) => (props.variant === 'plain' ? '36px' : null)};
    }

    ${promoMedia.desktop1440} {
        min-height: ${(props) => (props.variant === 'plain' ? '333px' : null)};
        border-radius: ${(props) => (props.variant === 'plain' ? '40px' : null)};
    }
`;

const Container = styled.div`
    ${commonCss};
    box-shadow: ${(props) => getBoxShadow(props)};
    background: ${(props) => promoColors[props.bgColor]};
    padding: ${(props) => (props.variant === 'iconTile' ? '16px' : props.variant === 'contentRow' ? '0' : '32px')};
    width: 100%;
    box-sizing: border-box;
    text-align: ${(props) => (props.variant === 'halfWidth' || props.variant === 'iconTile' ? 'center' : null)};

    ${promoMedia.tablet744} {
        padding: ${(props) => (props.variant === 'iconTile' ? '16px' : props.variant === 'contentRow' ? '0' : '48px')};
    }
`;
const TopContainer = styled.div`
    margin-bottom: ${(props) => (props.variant === 'halfWidth' || props.variant === 'contentRow' || props.variant === 'iconTile' ? '16px' : '8px')};

    ${promoMedia.tablet744} {
        margin-bottom: ${(props) => (props.variant === 'halfWidth' || props.variant === 'contentRow' || props.variant === 'iconTile' ? '16px' : '12px')};
    }

    ${promoMedia.desktop1440} {
        margin-bottom: 16px;
    }
`;

export const HighlightedTile = ({ bgColor = 'eggshell02', titleGradient = 'passionFruit01', ...props }) => {
    return (
        <Container bgColor={bgColor} variant={props.variant}>
            {props.icon && (
                <TopContainer variant={props.variant}>
                    <IconSvg img={props.icon} width={props.variant === 'iconTile' ? '60' : null} height={props.variant === 'iconTile' ? '60' : null} />
                </TopContainer>
            )}
            {props.title && (
                <TopContainer variant={props.variant}>
                    <PromoDangerouslyHtml tag="div" variant="h4" color={props.color} gradientColor={titleGradient} dangerouslyHtml={props.title} />
                </TopContainer>
            )}
            {props.text && props.variant === 'iconTile' && <PromoDangerouslyHtml tag="div" variant="subheader" color="gray80" dangerouslyHtml={props.text} />}
            {props.text && props.variant !== 'iconTile' && <PromoDangerouslyHtml tag="div" color="gray80" dangerouslyHtml={props.text} />}
        </Container>
    );
};

HighlightedTile.propTypes = {
    variant: PropTypes.oneOf(['plain', 'halfWidth', 'contentRow', 'iconTile']),
    bgColor: PropTypes.oneOf(['white', 'purple5', 'gray5', 'eggshell01', 'eggshell02', 'eggshell03', 'transparent']),
    color: PropTypes.oneOf(['baseColor', 'primary', 'primaryB2B', 'purple80', 'purple40', 'purple20', 'gray80', 'gray40', 'gray20', 'white']),
    titleGradient: PropTypes.oneOf([
        'aubergine01',
        'aubergine02',
        'aubergine03',
        'passionFruit01',
        'passionFruit02',
        'passionFruit03',
        'oceanBlue01',
        'oceanBlue02',
        'oceanBlue03',
        'blueberryBlue01',
        'blueberryBlue02',
        'blueberryBlue03',
        'jade01',
        'jade02',
        'jade03',
    ]),
    icon: PropTypes.object,
    title: PropTypes.string,
    text: PropTypes.string,
};
